module.exports = __webpack_public_path__ + "img/play-overlay.05b6c1ff.svg";